__turbopack_context__.v({
  "description": "styles-module__JooUea__description",
  "descriptionCollapseIcon": "styles-module__JooUea__descriptionCollapseIcon",
  "descriptionExpandIcon": "styles-module__JooUea__descriptionExpandIcon",
  "toggleDescriptionBtn": "styles-module__JooUea__toggleDescriptionBtn",
});
